import React, { useState, useEffect, useRef } from "react";
import Image from "react-bootstrap/Image";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Offcanvas from "react-bootstrap/Offcanvas";
import Collapse from "react-bootstrap/Collapse";
import StartNewConversation from "./StartNewConversation";
import {
  CubeIcon,
  EditIcon,
  VideoCameraIcon,
  XIcon,
} from "../../components/SVGIcon";
import { UsersFillIcon } from "../../components/Sidebar/SidebarIcons";
import { getExpertChatList } from "../../services/chatServices";
import { useAlert } from "../../contexts/AlertContext";
import { endConversationRequest } from "../../services/supportService";
import { useAtom, useAtomValue } from "jotai";
import { authAtom } from "../../states/auth";
import ImagePreviewLightbox from "../../components/ImagePreviewLightbox";
import eventBus from "../../utils/eventBus";
import { motion, AnimatePresence } from "framer-motion";
import StatusDot from "../../components/UserStatusdotColor";
import { useUserStatus } from "../../components/liveStatus";
import UserStatusDropDown from "../../components/UserStatusDropDown";
import { singleUser, updateUserstatus } from "../../services/userService";
import ConversationItem from "./ConversationItem";
import { useNavigate } from "react-router-dom";
import { useDebounce } from "../../hooks/useDebounce";
import { chatUnseenCountsAtom } from "../../states/chatAtoms";

const formatDateTimeToString = (dateObjTmp) => {
  const dateObj = new Date(dateObjTmp);
  if (dateObj) {
    const formattedDate = dateObj.toLocaleDateString("en-GB"); // Gives "dd/mm/yyyy"
    const formattedTime = dateObj.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, // ensures AM/PM format
    });
    const formattedDateWithDashes = formattedDate?.replace(/\//g, "-"); // converts dd/mm/yyyy to dd-mm-yyyy
    return `${formattedDateWithDashes}, ${formattedTime}`;
  }
};

const ChatSidebar = ({
  preSelectedConversationId,
  reorderConversations,
  inboxConversations,
  setInboxConversations,
  conversationId,
  setConversationId,
  chatScreenFilter,
  setChatScreenFilter,
}) => {
  const [newChatShow, setNewChatShow] = useState(false);
  const [createGroup, setCreateGroup] = useState(false);
  const [createCompany, setCreateCompany] = useState(false);
  // const [unseenCounts, setUnseenCounts] = useState({});
  const [companyDetailsCollapse, setCompanyDetailsCollapse] = useState(false);
  const [productCollapse, setProductCollapse] = useState(false);
  const [userData, setUserData] = useState({});
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  // const [inboxConversations, setInboxConversations] = useState(null);
  const [pendingInboxConversations, setPendingInboxConversations] =
    useState(null);
  const handleNewChatClose = () => setNewChatShow(false);
  const handleNewChatShow = () => setNewChatShow(true);
  const { showAlert } = useAlert();
  const auth = useAtomValue(authAtom);
  const navigate = useNavigate();

  console.log("auth", auth);
  const removeConversationById = (idToRemove) => {
    let updatedPending = [];
    let updatedInbox = [];

    setPendingInboxConversations((prev) => {
      const filtered = prev?.filter((item) => item.id !== idToRemove) || [];
      updatedPending = filtered;
      return filtered;
    });

    setInboxConversations((prev) => {
      const filtered = prev?.filter((item) => item.id !== idToRemove) || [];
      updatedInbox = filtered;
      return filtered;
    });
    console.log("END_SUPPORT_REQUEST", conversationId);
    console.log("END_SUPPORT_REQUEST", idToRemove);
    console.log("END_SUPPORT_REQUEST", updatedInbox[0]);
    if (conversationId === idToRemove) {
      // Use the filtered values captured above
      const firstAvailable = updatedInbox[0] || null;
      setConversationId(firstAvailable?.id || null);
    }
  };

  const chagneChatScreenFilter = (name, value) => {
    chatScreenFilter[name] = value;
    setChatScreenFilter({ ...chatScreenFilter });
  };

  useEffect(() => {
    const handleEndSupportRequest = (data) => {
      console.log("END_SUPPORT_REQUEST received:", data);
      if (data?.id) {
        removeConversationById(data.id);
      }
    };

    const handleNewConversation1 = (data) => {
      setChatScreenFilter({ ...chatScreenFilter });
    };

    const handleNewConversation = (data) => {
      const existingIndex = inboxConversations.findIndex(
        (item) => item?.id === data?.id,
      );
      // alert(existingIndex)
      const isSuppport = data?.conversationType.includes("support");
      const callSatus = data?.conversationStatus.includes("support");
      if (!isSuppport) {
        if (existingIndex != -1) {
          reorderConversations(data?.id);
        } else {
          setInboxConversations([data, ...inboxConversations]);
        }
      }

      // setChatScreenFilter({ ...chatScreenFilter })
    };

    const handleAcceptChatRequest = (data) => {
      const isChatType = data?.conversationType === "support chat";
      if (isChatType) {
        setPendingInboxConversations((prev) =>
          prev ? prev.filter((item) => item.id !== data.id) : [],
        );
        setConversationId(null);
        setInboxConversations((prev) => {
          const exists = prev?.some((item) => item.id === data.id);
          if (exists) {
            reorderConversations(data.id);
            return prev;
          } else {
            return [data, ...(prev || [])];
          }
        });

        setConversationId(null);
        setTimeout(() => {
          setConversationId(data.id);
        }, 50);
      }
    };

    const handleUnseenMessage = (data) => {
      const id = data.conversation_id;

      // setUnseenCounts(prev => {
      //   if (id === conversationId) return prev;
      //   return {
      //     ...prev,
      //     [id]: (prev[id] || 0) + 1
      //   };
      // });
      reorderConversations(id);
    };
    eventBus.on("NEW_SUPPORT_REQUEST", handleNewConversation);
    eventBus.on("NEW_INTERNAL_REQUEST", handleNewConversation);
    eventBus.on("END_SUPPORT_REQUEST", handleEndSupportRequest);
    eventBus.on("UNSEEN_MESSAGE", handleUnseenMessage);
    eventBus.on("ACCEPT_REQUEST", handleAcceptChatRequest);
    return () => {
      eventBus.off("UNSEEN_MESSAGE", handleUnseenMessage);
      eventBus.off("NEW_SUPPORT_REQUEST", handleNewConversation);
      eventBus.off("NEW_INTERNAL_REQUEST", handleNewConversation);
      eventBus.off("END_SUPPORT_REQUEST", handleEndSupportRequest);
      eventBus.off("ACCEPT_REQUEST", handleAcceptChatRequest);
    };
  }, [conversationId]);

  useEffect(() => {
    chagneChatScreenFilter("search", debouncedSearch);
  }, [debouncedSearch]);

  const [, setUnseenCounts] = useAtom(chatUnseenCountsAtom);
  useEffect(() => {
    if (conversationId) {
      setUnseenCounts((prev) => {
        const updated = { ...prev };
        delete updated[conversationId];
        return updated;
      });
    }
  }, [conversationId, setUnseenCounts]);

  const getChatConversationsData = async () => {
    try {
      const data = await getExpertChatList(chatScreenFilter);
      console.log("conversations list", data?.data);
      const temp = data?.data?.filter(
        (element) => element.conversationStatus == "Pending",
      );
      const temp1 = data?.data?.filter(
        (element) => element.conversationStatus !== "Pending",
      );
      setInboxConversations(temp1);
      setPendingInboxConversations(temp);
      // alert(preSelectedConversationId);
      // if(preSelectedConversationId != null && conversationId == null && temp1?.length > 0){

      // if (preSelectedConversationId != null && conversationId == null && temp1?.length > 0) {

      //   if (temp1?.map((e) => e?.id).includes(preSelectedConversationId)) {
      //     setConversationId(preSelectedConversationId)
      //   } else {
      //     setConversationId(temp1[0]?.id)
      //   }
      // } else {
      //   console.log("tmp1111", temp1 && temp1[0]?.id)
      //   setConversationId(temp1 && temp1[0]?.id)
      // }
    } catch (error) {
      console.error("Error fetching chat conversation:", error);
      showAlert({
        title: "Chat Screen Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
    }
  };

  useEffect(() => {
    getChatConversationsData();
  }, [chatScreenFilter]);

  const handleStatusChange = (val) => {
    if ([1, 2, 3, 4].includes(val)) {
      const apiParams = {
        status: val,
        // user_id: userData.id
      };

      updateUserstatus(apiParams)
        .then((res) => {
          showAlert({
            title: "Users Notification",
            message: res?.message ?? "Status updated successfully",
            variant: "success",
          });
        })
        .catch((error) =>
          showAlert({
            title: "Users Notification",
            message:
              error?.response?.data?.message ?? "Status failed to update",
            variant: "danger",
          }),
        );
    }
  };

  setTimeout(() => {
    const element = document.getElementById(`conv-${conversationId}`);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "nearest",
      });
    }
  }, 100);

  useEffect(() => {
    singleUser(auth?.user?.id).then((response) => {
      if (response?.data?.user) {
        const tempUserData = response?.data?.user;
        setUserData(tempUserData);
      }
    });
  }, [auth?.user?.id]);
  const liveStatus = useUserStatus(auth?.user?.id);

  const sessionLabelMap = {
    all: "All Chats",
    client: "Received",
    internal: "Internal",
    experts: "Requested",
    groups: "Groups",
  };
  return (
    <>
      <aside className="chat-sidebar">
        <div className="chat-profile">
          <div className="d-flex align-items-center gap-3">
            <ImagePreviewLightbox
              className="chat-avatar md position-relative"
              src={auth?.user?.profilePic || "/images/user-circle.svg"}
            >
              <Image
                className="rounded-pill object-fit-cover"
                onError={(e) => {
                  e.target.src = "/images/user-circle.svg";
                }}
                src={auth?.user?.profilePic || "/images/user-circle.svg"}
                width={48}
                height={48}
                alt="Expert"
              />
              <StatusDot statusCode={liveStatus ?? userData?.status} />
            </ImagePreviewLightbox>
            <div className="fs-16 fw-semibold text-gray-700 mb-1">
              {auth?.user?.firstName} {auth?.user?.lastName}
            </div>
          </div>
          <UserStatusDropDown
            className="sm"
            currentVal={userData?.status}
            onStatusChange={handleStatusChange}
          />
        </div>

        <div className="chat-filters">
          <input
            onChange={(e) => setSearch(e.target.value)}
            id="search"
            type="text"
            className="form-control form-control-search bg-gray-100 border-0 chat-search"
            placeholder="Search here..."
          />
          <div className="chat-filter-tabs">
            <button
              value="all"
              type="button"
              onClick={(e) => chagneChatScreenFilter("filter", e.target.value)}
              class={`chat-filter ${chatScreenFilter.filter === "all" ? "active" : ""}`}
            >
              All
            </button>
            <button
              value="client"
              type="button"
              onClick={(e) => chagneChatScreenFilter("filter", e.target.value)}
              class={`chat-filter ${chatScreenFilter.filter === "client" ? "active" : ""}`}
            >
              Received
            </button>
            <button
              value="experts"
              type="button"
              onClick={(e) => chagneChatScreenFilter("filter", e.target.value)}
              class={`chat-filter ${chatScreenFilter.filter === "experts" ? "active" : ""}`}
            >
              Requested
            </button>
            <button
              type="button"
              onClick={(e) => chagneChatScreenFilter("filter", e.target.value)}
              value="internal"
              class={`chat-filter ${chatScreenFilter.filter === "internal" ? "active" : ""}`}
            >
              Internal
            </button>
            <button
              type="button"
              onClick={(e) => chagneChatScreenFilter("filter", e.target.value)}
              value="groups"
              class={`chat-filter ${chatScreenFilter.filter === "groups" ? "active" : ""}`}
            >
              Groups
            </button>
            {/* <button type="button" onClick={(e)=>chagneChatScreenFilter("filter",e.target.value)} class={`chat-filter ${chatScreenFilter.filter === }`}>
              Pending
            </button> */}
          </div>
        </div>

        <div className="chat-list">
          {pendingInboxConversations?.length > 0 && (
            <>
              <p className="px-3 py-2 fs-14 fw-semibold text-gray-500 lh-lg mb-0">
                Requested
              </p>

              {pendingInboxConversations
                .slice()
                .sort(
                  (a, b) =>
                    new Date(a?.startTime || a?.createdAt) -
                    new Date(b?.startTime || b?.createdAt),
                )
                .map((element) => {
                  const isSupport =
                    element?.conversationType?.includes("support");

                  return (
                    <div
                      key={element?.id}
                      id={`conv-${element?.id}`}
                      className={`chat-list-item ${
                        conversationId === element?.id ? "active" : ""
                      }`}
                      onClick={() => setConversationId(element.id)}
                    >
                      <ImagePreviewLightbox
                        className="chat-avatar md"
                        src={
                          element?.admin?.profilePic ||
                          "/images/user-circle.svg"
                        }
                      >
                        <Image
                          className="rounded-pill object-fit-cover"
                          src={
                            element?.admin?.profilePic ||
                            "/images/user-circle.svg"
                          }
                          onError={(e) => {
                            e.currentTarget.src = "/images/user-circle.svg";
                          }}
                          width={48}
                          height={48}
                          alt="Expert"
                        />
                      </ImagePreviewLightbox>

                      <div className="d-flex flex-column align-items-start justify-content-between gap-1">
                        <div className="fs-16 fw-semibold text-gray-700">
                          <span className="text-truncate">
                            {element?.admin?.companyName}
                          </span>

                          {isSupport && (
                            <span className="text-truncate fs-14 fw-normal text-gray-500 d-block">
                              Expertise – {element?.expertise?.name}
                            </span>
                          )}
                        </div>

                        <div className="fs-14 fw-normal text-gray-500">
                          {formatDateTimeToString(
                            element?.startTime || element?.createdAt,
                          )}
                        </div>
                      </div>

                      <div className="d-flex flex-column align-items-end justify-content-center align-self-start ms-auto gap-2">
                        <span className="badge badge-warning mt-1">
                          Pending
                        </span>
                      </div>
                    </div>
                  );
                })}
            </>
          )}
          <p className="px-3 py-2 fs-14 fw-semibold text-gray-500 lh-lg mb-0">
            {sessionLabelMap[chatScreenFilter.filter] || "All Chats"}
          </p>
          {/* <div className="chat-list-item active">
            <div className="chat-avatar md">
              <Image
                src="/images/users-three-rounded.svg"
                width={48}
                height={48}
                alt="Users Three Icon"
              />
            </div>
            <div className="d-flex flex-column align-items-start justify-content-between gap-1">
              <div className="fs-20 fw-semibold text-gray-700">
                <span className="text-truncate">AssistChat Group</span>
              </div>
            </div>
          </div> */}
          <AnimatePresence>
            {inboxConversations?.map((element) => (
              <ConversationItem
                key={element.id}
                element={element}
                conversationId={conversationId}
                setConversationId={setConversationId}
                auth={auth}
                // unseenCounts={unseenCounts}
              />
            ))}
          </AnimatePresence>
        </div>

        <Button
          type="button"
          className="add-chat-btn"
          onClick={handleNewChatShow}
        >
          <Image
            src="/images/chat-circle-plus-white.svg"
            width={22}
            height={22}
            alt="Chat Circle Plus White Icon"
          />
        </Button>
      </aside>

      {/* New Chat Offcanvas */}
      {false && (
        <Offcanvas
          show={newChatShow}
          onHide={handleNewChatClose}
          placement="end"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title className="fs-20 fw-semibold text-gray-700">
              {createGroup ? "New Chat11 Group" : "New Chat"}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="company-details-collapse">
              <Button
                variant=""
                className="company-details-collapse-btn w-100 d-flex align-items-center justify-content-between gap-4"
                onClick={() =>
                  setCompanyDetailsCollapse(!companyDetailsCollapse)
                }
                aria-controls="company-details-collapse"
                aria-expanded={companyDetailsCollapse}
              >
                <div className="d-flex align-items-center gap-3">
                  <Image
                    src="/images/company-icon.svg"
                    width={56}
                    height={56}
                    alt="Company Icon"
                  />
                  <div className="d-flex flex-column align-items-start gap-1">
                    <p className="fs-16 fw-semibold text-gray-700 mb-0">
                      OEM Company
                    </p>
                    <ul className="d-flex align-items-center gap-2 list-unstyled mb-0">
                      <li className="fs-14 fw-medium text-blue-600">Open</li>
                      <li className="dot-separator"></li>
                      <li className="fs-14 fw-normal text-gray-500">
                        Closes 8PM
                      </li>
                    </ul>
                  </div>
                </div>
                <Image
                  className="company-details-collapse-btn-arrow"
                  src="/images/caret-down-rounded-gray.svg"
                  width={32}
                  height={32}
                  alt="Company Icon"
                />
              </Button>
              <Collapse in={companyDetailsCollapse}>
                <div
                  id="company-details-collapse"
                  className="company-details-collapse-info"
                >
                  <ul className="d-flex flex-column align-items-start gap-2 list-unstyled mb-0">
                    <li className="fs-14 text-gray-700 d-flex align-items-center gap-2">
                      <Image
                        className="company-details-collapse-btn-arrow"
                        src="/images/envelope-blue.svg"
                        width={18}
                        height={18}
                        alt="Envelope Icon"
                      />
                      <span>company_23@email.com</span>
                    </li>
                    <li className="fs-14 text-gray-700 d-flex align-items-center gap-2">
                      <Image
                        className="company-details-collapse-btn-arrow"
                        src="/images/phone-call-blue.svg"
                        width={18}
                        height={18}
                        alt="Phone Icon"
                      />
                      <span>+1 (813) 548-2181</span>
                    </li>
                    <li className="fs-14 text-gray-700 d-flex align-items-center gap-2">
                      <Image
                        className="company-details-collapse-btn-arrow"
                        src="/images/map-pin-blue.svg"
                        width={18}
                        height={18}
                        alt="Map Pin Icon"
                      />
                      <span>
                        4995 Clark Street, Chicago, Illinois, USA 606314995
                        Clark Street, Chicago, Illinois, USA 60631
                      </span>
                    </li>
                  </ul>
                </div>
              </Collapse>
            </div>

            {createGroup && (
              <div className="create-group-box">
                <div className="create-group-box-icon">
                  <EditIcon />
                  <UsersFillIcon className="hover-icon" />
                </div>
                <input
                  className="create-group-box-input"
                  placeholder="Enter group name"
                />
              </div>
            )}

            {!createGroup && (
              <div className="chat-filters p-0">
                <input
                  type="text"
                  className="form-control form-control-search bg-gray-100 border-0 chat-search"
                  placeholder="Search here..."
                />
                <div className="chat-filter-tabs">
                  <button type="button" className="chat-filter active">
                    All Users
                  </button>
                  <button type="button" className="chat-filter">
                    Internal
                  </button>
                  <button type="button" className="chat-filter">
                    Experts
                  </button>
                </div>
              </div>
            )}
            {createGroup && (
              <Button
                variant=""
                type="button"
                className="w-100 bg-white shadow-none border border-grey-200 rounded-4 d-flex align-items-center gap-3 p-3 mt-4"
                onClick={() => setCreateGroup(true)}
              >
                <Image
                  src="/images/users-three-rounded.svg"
                  width={48}
                  height={48}
                  alt="Users Three Icon"
                />
                <p className="fs-16 fw-fw-semibold text-gray-700 mb-0">
                  New Chat Group
                </p>
              </Button>
            )}

            {createGroup && (
              <input
                type="text"
                className="form-control form-control-search bg-gray-100 border-0 chat-search"
                placeholder="Search here..."
              />
            )}

            {createGroup && (
              <div className="chat-contact-list mt-3">
                <div className="mb-4">
                  <h3 className="fs-16 fw-bold px-2 mb-2">A</h3>
                  <div className="chat-contact chat-contact-check d-flex align-items-center flex-row-reverse justify-content-between gap-3">
                    <input type="checkbox" name="a" id="user-1" />
                    <label
                      htmlFor="user-1"
                      className="chat-contact-label w-100 d-flex align-items-center justify-content-between border-bottom border-grey-200 px-2 py-3 gap-3"
                    >
                      <div className="d-flex align-items-center gap-3">
                        <Image
                          className="rounded-pill"
                          src="/images/user-avatar-1.png"
                          width={48}
                          height={48}
                          alt="User Icon"
                        />
                        <p className="fs-16 fw-semibold text-gray-700 mb-0">
                          Internal User
                        </p>
                      </div>
                    </label>
                  </div>
                  <div className="chat-contact chat-contact-check d-flex align-items-center flex-row-reverse justify-content-between gap-3">
                    <input type="checkbox" name="a" id="user-2" />
                    <label
                      htmlFor="user-2"
                      className="chat-contact-label w-100 d-flex align-items-center justify-content-between border-bottom border-grey-200 px-2 py-3 gap-3"
                    >
                      <div className="d-flex align-items-center gap-3">
                        <Image
                          className="rounded-pill"
                          src="/images/user-avatar-1.png"
                          width={48}
                          height={48}
                          alt="User Icon"
                        />
                        <p className="fs-16 fw-semibold text-gray-700 mb-0">
                          Internal User
                        </p>
                      </div>
                    </label>
                  </div>
                  <div className="chat-contact chat-contact-check d-flex align-items-center flex-row-reverse justify-content-between gap-3">
                    <input type="checkbox" name="a" id="user-3" />
                    <label
                      htmlFor="user-3"
                      className="chat-contact-label w-100 d-flex align-items-center justify-content-between border-bottom border-grey-200 px-2 py-3 gap-3"
                    >
                      <div className="d-flex align-items-center gap-3">
                        <Image
                          className="rounded-pill"
                          src="/images/user-avatar-3.png"
                          width={48}
                          height={48}
                          alt="User Icon"
                        />
                        <p className="fs-16 fw-semibold text-gray-700 mb-0">
                          Internal User
                        </p>
                      </div>
                    </label>
                  </div>
                </div>
                <div className="mb-4">
                  <h3 className="fs-16 fw-bold px-2 mb-2">B</h3>
                  <div className="chat-contact chat-contact-check d-flex align-items-center flex-row-reverse justify-content-between gap-3">
                    <input type="checkbox" name="a" id="user-5" />
                    <label
                      htmlFor="user-5"
                      className="chat-contact-label w-100 d-flex align-items-center justify-content-between border-bottom border-grey-200 px-2 py-3 gap-3"
                    >
                      <div className="d-flex align-items-center gap-3">
                        <Image
                          className="rounded-pill"
                          src="/images/user-avatar-1.png"
                          width={48}
                          height={48}
                          alt="User Icon"
                        />
                        <p className="fs-16 fw-semibold text-gray-700 mb-0">
                          Internal User
                        </p>
                      </div>
                    </label>
                  </div>
                  <div className="chat-contact chat-contact-check d-flex align-items-center flex-row-reverse justify-content-between gap-3">
                    <input type="checkbox" name="a" id="user-4" />
                    <label
                      htmlFor="user-4"
                      className="chat-contact-label w-100 d-flex align-items-center justify-content-between border-bottom border-grey-200 px-2 py-3 gap-3"
                    >
                      <div className="d-flex align-items-center gap-3">
                        <Image
                          className="rounded-pill"
                          src="/images/user-avatar-1.png"
                          width={48}
                          height={48}
                          alt="User Icon"
                        />
                        <p className="fs-16 fw-semibold text-gray-700 mb-0">
                          Internal User
                        </p>
                      </div>
                    </label>
                  </div>
                  <div className="chat-contact chat-contact-radio d-flex align-items-center flex-row-reverse justify-content-between gap-3">
                    <input type="radio" name="b" id="user-11" />
                    <label
                      htmlFor="user-11"
                      className="chat-contact-label w-100 d-flex align-items-center justify-content-between border-bottom border-grey-200 px-2 py-3 gap-3"
                    >
                      <div className="d-flex align-items-center gap-3">
                        <Image
                          className="rounded-pill"
                          src="/images/product-icon.png"
                          width={48}
                          height={48}
                          alt="User Icon"
                        />
                        <p className="fs-16 fw-semibold text-gray-700 mb-0">
                          Product Name
                        </p>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            )}
          </Offcanvas.Body>
          <div className="offcanvas-footer">
            {!createCompany && (
              <Button variant="primary" className="btn-md">
                {createGroup ? "Create Chat Group" : "Start Chat"}
              </Button>
            )}
            {createCompany && (
              <Button
                variant="primary"
                className="btn-md"
                onClick={() => setCreateCompany(true)}
              >
                Next
              </Button>
            )}
            <Button
              variant="outline-secondary"
              className="btn-md"
              onClick={handleNewChatClose}
            >
              Cancel
            </Button>
          </div>
        </Offcanvas>
      )}

      <StartNewConversation
        newChatSidebar={newChatShow}
        setConversationId={setConversationId}
        inboxConversations={inboxConversations}
        setNewChatSidebar={setNewChatShow}
        getCalenderList={getChatConversationsData}
      />
    </>
  );
};

export default ChatSidebar;
